import { mapChannelFromDTO } from '@entities/channel/api/mappers'
import type { Channel, ChannelDTO } from '@entities/channel/model/types'
import { httpClient } from '@shared/api'
import type { Partner, PartnerDTO, PartnerOrd, PartnerOrdDTO } from '../model/types'
import { mapPartnerFromDTO, mapPartnerORDFromDTO, mapPartnerORDToDTO, mapPartnerToDTO } from './mappers'
import type {
    CreatePartnerArgs,
    CreatePartnerOrdArgs,
    DeletePartnerArgs,
    EditPartnerArgs,
    GetPartnerResourcesArgs,
    LinkPartnerArgs
} from './types'

export const getPartners = async (channelId?: number): Promise<Partner[]> => {
    const { data: result } = await httpClient.get<PartnerDTO[]>('/partners', { params: { channel_id: channelId } })
    return result.map(mapPartnerFromDTO)
}

export const getPartner = async (id?: number, channelId?: number): Promise<Partner> => {
    const { data: result } = await httpClient.get<PartnerDTO>(`/partners/${id}`, { params: { channel_id: channelId } })
    return mapPartnerFromDTO(result)
}

export const getPartnerOrd = async (id: number): Promise<PartnerOrd> => {
    const { data: result } = await httpClient.get<PartnerOrdDTO>(`/partners/${id}/ord`)
    return mapPartnerORDFromDTO(result)
}

export const createPartnerOrd = async ({ partnerId, data }: CreatePartnerOrdArgs): Promise<PartnerOrd> => {
    const { data: result } = await httpClient.put<PartnerOrdDTO>(`/partners/${partnerId}/ord`, mapPartnerORDToDTO(data))
    return mapPartnerORDFromDTO(result)
}

export const getPartnersResources = async (): Promise<Channel[]> => {
    const { data: result } = await httpClient.get<ChannelDTO[]>(`/partners/resources`)
    return result.map(mapChannelFromDTO)
}

export const createPartner = async (data: CreatePartnerArgs): Promise<Partner> => {
    const { data: result } = await httpClient.post<PartnerDTO>('/partners', mapPartnerToDTO(data))
    return mapPartnerFromDTO(result)
}

export const editPartner = async ({ id, data }: EditPartnerArgs): Promise<Partner> => {
    const { data: result } = await httpClient.patch<PartnerDTO>(`/partners/${id}`, mapPartnerToDTO(data))
    return mapPartnerFromDTO(result)
}

export const deletePartner = async ({ id }: DeletePartnerArgs): Promise<void> => {
    await httpClient.delete<PartnerDTO>(`/partners/${id}`)
}

export const linkPartner = async ({ partnerId }: LinkPartnerArgs): Promise<void> => {
    await httpClient.post(`/partners/link_user`, {
        partner_id: partnerId
    })
}

export const unlinkPartner = async ({ partnerId }: LinkPartnerArgs): Promise<void> => {
    await httpClient.post(`/partners/unlink_user`, {
        partner_id: partnerId
    })
}

export const getPartnerResources = async ({ partnerId }: GetPartnerResourcesArgs): Promise<Channel[]> => {
    const { data: result } = await httpClient.get<ChannelDTO[]>(`/partners/${partnerId}/channels`)
    return result.map(mapChannelFromDTO)
}
